import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Gift, CreditCard, ClipboardList, Users } from 'lucide-react';
const bonuses = [{
  id: 'B1',
  icon: CreditCard,
  iconColor: 'text-brand-orange',
  iconBg: 'bg-brand-orange/10',
  title: 'TARJETA EPILEPSIA BAJO CONTROL™',
  intro: 'Sistema completo de tarjetas y documentos de emergencia para imprimir:',
  bullets: ['Tarjeta de heladera con protocolo visual', 'Tarjeta para la mochila del niño', 'Carta completa para la directora del colegio', 'Autorización de administración de medicación de rescate', 'Plan de acción escolar personalizable', 'Kit de documentos para viajes y salidas', 'Carta médica para guardia de emergencia'],
  tagline: 'Para que todos los que rodean a tu hijo sepan exactamente qué hacer.'
}, {
  id: 'B2',
  icon: ClipboardList,
  iconColor: 'text-brand-amber',
  iconBg: 'bg-brand-amber/10',
  title: 'DIARIO DE CONVULSIONES Y SEGUIMIENTO 2026',
  intro: 'El registro que el neurólogo va a agradecer en cada consulta:',
  bullets: ['Perfil médico completo del niño', '12 planillas mensuales de registro', 'Ficha detallada de cada crisis', 'Control de medicación y dosis', 'Control de medicación de rescate', 'Seguimiento del sueño y bienestar', 'Termómetro emocional de mamá', 'Resumen de consulta médica', 'Historial de estudios completo', 'Preguntas estratégicas para el neurólogo'],
  tagline: 'Para que cada consulta sea más efectiva que la anterior.'
}, {
  id: 'B3',
  icon: Users,
  iconColor: 'text-brand-green',
  iconBg: 'bg-brand-green/10',
  title: 'GUÍA FAMILIA BAJO CONTROL™',
  intro: 'Porque la epilepsia no la maneja mamá sola:',
  bullets: ['Guía específica para el papá', 'Guía para los abuelos', 'Guía para los hermanos', 'Guía completa para docentes', 'Plan familiar de emergencia', 'División de responsabilidades en casa', 'Frases útiles y frases que nunca hay que decir', 'Recursos de apoyo en Argentina: grupos, asociaciones y profesionales'],
  tagline: 'Para que toda la red de tu hijo esté preparada.'
}];
export const Bonuses = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-brand-green text-white relative overflow-hidden" data-id="element-18">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-19">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-20"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-orange rounded-full blur-3xl" data-id="element-21"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-22">
        <div className="text-center mb-8 sm:mb-12" data-id="element-23">
          <div className="inline-flex items-center gap-2 bg-brand-gold text-white font-bold px-4 py-1.5 rounded-full text-sm mb-4 sm:mb-6" data-id="element-24">
            <Gift size={16} data-id="element-25" /> INCLUIDOS GRATIS
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold mb-3 sm:mb-4" data-id="element-26">
            3 BONOS INCLUIDOS GRATIS
          </h2>
          <p className="text-lg sm:text-xl text-cream/90" data-id="element-27">
            Los Recursos de Acción Inmediata
          </p>
          <p className="text-sm sm:text-base text-cream/80 mt-2" data-id="element-28">
            Sin costo extra — incluidos en todas las opciones
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 mb-10 sm:mb-14 md:mb-16" data-id="element-29">
          {bonuses.map((bonus, i) => {
          const IconComponent = bonus.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} whileHover={{
            y: -4,
            transition: {
              duration: 0.2
            }
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: i * 0.1
          }} className="bg-white text-gray-900 rounded-2xl p-4 sm:p-5 shadow-lg border-t-4 border-brand-gold relative cursor-default flex flex-col" data-id="element-30">
                <div className="absolute -top-3 right-4 bg-brand-orange text-white text-xs font-bold px-2.5 py-0.5 rounded-full shadow-sm" data-id="element-31">
                  GRATIS
                </div>

                <div className={`w-16 h-16 ${bonus.iconBg} rounded-xl flex items-center justify-center mb-3 sm:mb-4`} data-id="element-32">
                  <IconComponent size={32} className={bonus.iconColor} data-id="element-33" />
                </div>

                <h3 className="font-bold text-base sm:text-lg mb-2 leading-tight" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-gray-700 text-sm font-medium mb-3" data-id="element-35">
                  {bonus.intro}
                </p>

                <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-36">
                  {bonus.bullets.map((b, j) => <li key={j} className="flex items-start gap-1.5 text-gray-600 text-xs sm:text-sm leading-relaxed" data-id="element-37">
                      <div className="mt-1.5 w-1.5 h-1.5 bg-brand-orange rounded-full flex-shrink-0" data-id="element-38" />
                      <span data-id="element-39">{b}</span>
                    </li>)}
                </ul>

                <p className="text-brand-green text-xs font-bold italic mt-auto pt-3 border-t border-gray-100" data-id="element-40">
                  {bonus.tagline}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 sm:p-6 md:p-8 text-center max-w-3xl mx-auto" data-id="element-41">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold" data-id="element-42">
            VALOR TOTAL DE LOS BONOS:{' '}
            <span className="line-through text-white/50" data-id="element-43">$45.000</span>{' '}
            <span className="text-brand-gold" data-id="element-44">— GRATIS</span>
          </h3>
        </div>
      </div>
    </section>;
};